import styled, { css } from 'styled-components';

export const Element = styled.div<{ active: boolean }>`
  ${({ theme, active, ...props }) => {
    return css`
      padding: ${theme.spacing.base} 0;
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        padding: ${theme.spacing.base} 0;
      }

      ${!active &&
      css`
        display: none;
      `}
    `;
  }};
`;
